import getInfoByIdVariantSelector from 'modules/variant/redux/selectors/get-info-by-id'

/**
 * TODO migrate to use `getProductVariantByIdProductSelector`
 * @param variantId
 * @returns {(state) => boolean}
 */
const isAvailableByIdVariantSelector = variantId => {
  /**
   * @param state
   * @returns {boolean}
   */
  return state => {
    const variantInfo = getInfoByIdVariantSelector(variantId)(state)
    return variantInfo?.available !== false
  }
}

export default isAvailableByIdVariantSelector
